import script from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientUploadsDialog.vue?vue&type=script&setup=true&lang=js"

import "./ClientUploadsDialog.vue?vue&type=style&index=0&id=1d30c07b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d30c07b"]])

export default __exports__